import { createReducer } from "deox";

import {
  dueChargesLoaded,
  dueChargesLoading,
  failed,
  moreDueChargesLoaded,
  moreDueChargesLoading,
  statementInformationLoaded,
  statementInformationLoading,
  moreStatementInformationLoading,
  moreStatementInformationLoaded,
} from "./dueChargesStateActions";
import { BillingCycleSummary, StatementInformation } from "../../../types/types";
import { purge } from "../purge/purgeStateActions";
export interface DueChargesState {
  dueCharges: BillingCycleSummary[];
  isError: boolean;
  isLoading: boolean;
  isMoreLoading: boolean;
  isLoaded: boolean;
  total: number;
  page: number;
  isLastPage: boolean;
}
export interface StatementInformationState {
  statementInformation: StatementInformation[];
  isError: boolean;
  isLoading: boolean;
  isMoreLoading: boolean;
  isLoaded: boolean;
  total: number;
  page: number;
  isLastPage: boolean;
}
export interface BillingState {
  dueChargesState: DueChargesState;
  statementInformationState: StatementInformationState;
}
const initialState: BillingState = {
  dueChargesState: {
    dueCharges: [],
    isMoreLoading: false,
    total: 0,
    isError: false,
    isLoading: false,
    page: 1,
    isLastPage: false,
    isLoaded: false,
  },
  statementInformationState: {
    statementInformation: [],
    isError: false,
    isLoading: false,
    isMoreLoading: false,
    isLoaded: false,
    total: 0,
    page: 1,
    isLastPage: false,
  },
};
const billingReducer = createReducer(initialState, (handleAction) => [
  // Due Charges Handlers
  handleAction(
    dueChargesLoaded,
    (state, action): BillingState => ({
      ...state,
      dueChargesState: {
        ...state.dueChargesState,
        isLoading: false,
        isLoaded: true,
        isError: false,
        dueCharges: action.payload.records,
        total: action.payload.total,
        page: action.meta,
        isLastPage: action?.payload?.records.length === 0 || action?.payload?.records.length >= action.payload.total,
      },
    })
  ),
  handleAction(
    moreDueChargesLoaded,
    (state, action): BillingState => ({
      ...state,
      dueChargesState: {
        ...state.dueChargesState,
        isLoading: false,
        isError: false,
        isMoreLoading: false,
        dueCharges: [...state.dueChargesState.dueCharges, ...action.payload.records],
        total: action.payload.total,
        page: action.meta,
        isLastPage: action?.payload?.records.length === 0 || action?.payload?.records.length >= action.payload.total,
      },
    })
  ),
  handleAction(
    dueChargesLoading,
    (state): BillingState => ({
      ...state,
      dueChargesState: {
        ...state.dueChargesState,
        isLoading: true,
        isLoaded: false,
        isMoreLoading: false,
        isError: false,
      },
    })
  ),
  handleAction(
    moreDueChargesLoading,
    (state): BillingState => ({
      ...state,
      dueChargesState: {
        ...state.dueChargesState,
        isLoading: false,
        isMoreLoading: true,
        isError: false,
      },
    })
  ),
  handleAction(
    failed,
    (state): BillingState => ({
      ...state,
      dueChargesState: {
        ...state.dueChargesState,
        isError: true,
        isLoading: false,
        isMoreLoading: false,
      },
    })
  ),
  // Statement Information Handlers
  handleAction(
    statementInformationLoaded,
    (state, action): BillingState => ({
      ...state,
      statementInformationState: {
        ...state.statementInformationState,
        isLoading: false,
        isLoaded: true,
        isError: false,
        statementInformation: action.payload.records,
        total: action.payload.total,
        page: action.meta,
        isLastPage: action?.payload?.records.length === 0 || action?.payload?.records.length >= action.payload.total,
      },
    })
  ),
  handleAction(
    statementInformationLoading,
    (state): BillingState => ({
      ...state,
      statementInformationState: {
        ...state.statementInformationState,
        isLoading: true,
        isLoaded: false,
        isError: false,
      },
    })
  ),
  handleAction(
    moreStatementInformationLoaded,
    (state, action): BillingState => ({
      ...state,
      statementInformationState: {
        ...state.statementInformationState,
        isLoading: false,
        isError: false,
        isMoreLoading: false,
        statementInformation: [...state.statementInformationState.statementInformation, ...action.payload.records],
        total: action.payload.total,
        page: action.meta,
        isLastPage: action?.payload?.records.length === 0 || action?.payload?.records.length >= action.payload.total,
      },
    })
  ),
  handleAction(
    moreStatementInformationLoading,
    (state): BillingState => ({
      ...state,
      statementInformationState: {
        ...state.statementInformationState,
        isLoading: false,
        isMoreLoading: true,
        isError: false,
      },
    })
  ),
  handleAction(purge, () => initialState),
]);
export default billingReducer;
